module.exports = __webpack_public_path__ + "static/ebook-cover-8ac24d8132c36f802a1b6003f8b7dfaf.png";